
import styles from "./TrusteesCards.module.css"; 

const TrusteesCards = () => {
  const values = [
    { name: "Dr. Mrs. Shubhangi Sachin Jadhav (BHMS)", role: "Former secretary" , picture: '/trustees/shubhangi_jadhav.webp'},
    { name: "Mr. Jalindar Harishchandra Mohite (M.com B.ed)", role: "Principal" , picture: '/trustees/Jalindar_mohite.webp'},
    { name: "Mr. Sandip Shivajirao Jadhav", role: "Vice President",  picture: '/trustees/Sandip_Jadhav.webp'},
    { name: "Mr. Malhari Bhiva Adagale", role: "Treasurer" , picture: '/trustees/malhari_Adgale.webp'},
    { name: "Mr. Pandurang Kondiba Raikar", role: "Trustee" , picture: '/trustees/Pandurang_Raikar.webp'},
    { name: "Dr. Sanjay Sitaram Kokate", role: "Trustee" , picture: '/trustees/sanjay_kokate.webp'},
    
  ];

  return (
    <div className={styles.cardsContainer}>
      {values.map((value, index) => (
        <div className={styles.card} key={index}>
            <img src={value.picture} alt={value.name}/>
          <p className={styles.name}>{value.name}</p>
          <p className={styles.role}>{value.role}</p>
          {/* <p className={styles.description}>{value.description}</p> */}
        </div>
      ))}
    </div>
  );
};

export default TrusteesCards;
